import { render, staticRenderFns } from "./ForumEventWordCloud.vue?vue&type=template&id=457715e3&scoped=true"
import script from "./ForumEventWordCloud.vue?vue&type=script&lang=js"
export * from "./ForumEventWordCloud.vue?vue&type=script&lang=js"
import style0 from "./ForumEventWordCloud.vue?vue&type=style&index=0&id=457715e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457715e3",
  null
  
)

export default component.exports